"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLAGS = void 0;
var FLAGS = {
  BILLING: 'billing',
  NEW_DASHBOARD: 'newDashboard',
  MARKETO_INTEGRATION: 'marketoIntegration',
  ELOQUA_INTEGRATION: 'eloquaIntegration',
  HUBSPOT_INTEGRATION: 'hubspotIntegration',
  DYNAMICS_INTEGRATION: 'dynamicsIntegration',
  SWAG_ADD_ON: 'swag add-on',
  ACTIVATE_PRODUCT: 'activateProduct',
  OLD_DASHBOARD: 'oldDashboard',
  BILLING_INSIGHTS: 'billingInsights',
  SALES_FORCE_APP_ACCESS: 'salesforceAppAccess',
  SHOW_REMAINING_DEPOSITS: 'showRemainingDeposits',
  MAIL_SENDER_AUTHENTICATION: 'mailSenderAuthentication',
  INTERNATIONAL: 'international',
  CONTACT_ENRICHMENT: 'contactEnrichment',
  CAN_USE_CUSTOM_FIELDS: 'canUseCustomFields',
  SHOW_DEPOSIT_LEDGER: 'showDepositLedger',
  ASSIST: 'assistFeature',
  SALESLOFT: 'salesloftIntegration',
  SF_API_INTEGRATION: 'sfApiIntegration',
  ALYCE_FOR_MARKETING: 'alyceForMarketing',
  GIFTING_ON_THE_FLY: 'giftingOnTheFly',
  MULTIPLE_GIFT_LINKS: 'multipleGiftLinks',
  ACCEPT_ONLY: 'acceptOnly',
  DISABLE_MARGIN: 'disableMargin',
  AUTOMATED_BILLING: 'automatedBilling',
  ONE_TO_MANY_MEETING_BOOKER: 'oneToManyMeetingBooker',
  OUTREACH: 'outreachIntegration',
  WORKATO_INTEGRATION: 'workatoIntegration',
  PUBLIC_API: 'publicApi',
  BUDGET_MANAGEMENT_SETUP: 'budgetManagementSetup',
  GIFT_REDEMPTION_CODES_2_0: 'giftRedemptionCodes20',
  BUDGET_MANAGEMENT_LIMIT: 'budgetManagementLimit',
  ONE_TO_MANY_FREE_CLAIMS: 'oneToManyFreeClaims',
  BILLING_OVERVIEW_2_0: 'billingOverviewV2',
  ARCHIVE_TEAMS: 'archiveTeams',
  DASHBOARD_STATISTICS_V3: 'dashboardStatisticsV3',
  MULTIPLE_GIFT_CARD_VALUES: 'multipleGiftCardValues',
  MANAGE_PROSPECTING_CAMPAIGN_TEMPLATE: 'manageProspectingCampaignTemplate',
  SALESFORCE_HAS_OPTED_OUT: 'salesforceHasOptedOut',
  GIFT_EXPIRATION_7_DAYS: 'giftExpiration7Days',
  INTERNATIONAL_REDEMPTION_CODES: 'internationalRedemptionCodes',
  RI_DASHBOARD_V2: 'riDashboardV2',
  DIRECT_MAIL: 'directMail',
  INFLUITIVE_INTEGRATION: 'influitiveIntegration',
  GIFTS_PAGE: 'giftsPage',
  REPORTING_SUITE_CTA_ORG_ADMIN: 'reportingSuiteCtaOrgAdmin',
  REPORTING_SUITE_CTA_TEAM_ADMIN: 'reportingSuiteCtaTeamAdmin',
  CHILIPIPER_INTEGRATION: 'chiliPiperIntegration',
  SEND_AS_BUDGET_SETTINGS: 'sendAsBudgetSettings',
  FREE_CLAIM_MAX_500: 'freeClaimMax500'
};
exports.FLAGS = FLAGS;